import cloneDeep from 'lodash/cloneDeep';
import transform from '@/services/baux/echeancierContrat/echeancierContratTableDataTransformer';
import {
  SET_ITEMS,
  SET_TOTAL,
  SET_CRITERE_RECHERCHE,
  SET_LAST_PAYLOAD,
} from '@/store/modules/baux/echeanceARapprocher-mutation-type';
import formatIsoDate from '@/services/general/formatIsoDate';
import * as allTypes from '@/store/mutation-type';
import getAll from '@/api/echeanceARapprocher/index';
import genererCritereRecherche
  from '@/services/baux/echeanceARapprocher/genererCritereRechercheEcheanceARapprocher';
import {
  getAffectationEcranNumerique,
  getAffectationProduitUnitaireAsync,
} from '@/api/affectation';
import { CATEGORIE_UNITAIRE } from '@/configuration/catalogue/produitConf';

function initialState() {
  return {
    items: [],
    total: 0,

    affectations: [],
    criteresRecherche: genererCritereRecherche(),
    cumulByTypeActionAchat: null,
    lastPayload: {},
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [SET_ITEMS](state, items) {
    state.items = items;
  },
  [SET_TOTAL](state, total) {
    state.total = total;
  },
  [SET_CRITERE_RECHERCHE](state, criteresRecherche) {
    state.criteresRecherche = criteresRecherche;
  },
  [SET_LAST_PAYLOAD](state, payload) {
    state.lastPayload = payload;
  },
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
};

const actions = {
  async loadEcheancesARapprocher({ commit }, data) {
    const result = await getAll(data);

    const echeanceProduitUnitaire = [];
    const echeanceProduitNumerique = [];
    result.data.result.items.forEach((echeanceAPayer) => {
      if (!echeanceAPayer.produitId) return;
      if (echeanceAPayer.typeProduit === CATEGORIE_UNITAIRE) {
        echeanceProduitUnitaire.push({
          id: echeanceAPayer.produitId,
          dureeAffectation: {
            dateDebut: formatIsoDate(echeanceAPayer.dateDebutEcheance),
            dateFin: formatIsoDate(echeanceAPayer.dateFinEcheance),
          },
        });
      } else {
        echeanceProduitNumerique.push({
          id: echeanceAPayer.produitId,
          dureeAffectation: {
            dateDebut: formatIsoDate(echeanceAPayer.dateDebutEcheance),
            dateFin: formatIsoDate(echeanceAPayer.dateFinEcheance),
          },
        });
      }
    });

    const affectationsUnitaire = (await getAffectationProduitUnitaireAsync(
      echeanceProduitUnitaire, false, true,
    )).data.result;
    const affectationsEcranNumerique = (await getAffectationEcranNumerique(
      echeanceProduitNumerique, false,
    )).data.result;

    result.data.result.items.forEach((echeanceAPayer) => {
      if (echeanceAPayer.typeProduit === CATEGORIE_UNITAIRE) {
        echeanceAPayer.affectations = affectationsUnitaire[echeanceAPayer.produitId];
      } else {
        echeanceAPayer.affectations = affectationsEcranNumerique[echeanceAPayer.produitId];
      }
    });

    commit(SET_ITEMS, result.data.result.items);
    commit(SET_TOTAL, result.data.result.totalCount);
    commit(SET_LAST_PAYLOAD, cloneDeep(transform(data)));
    return {};
  },
};

const getters = {
  items: state => {
    return state.items;
  },
  total: state => {
    return state.total;
  },
  criteresRecherche: state => {
    return state.criteresRecherche;
  },
  lastPayload: state => {
    return state.lastPayload;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
